export default class UserAgentCheck {
    static isApp(userAgent) {
        return new RegExp("^bonprix( mobile)? App ").test(userAgent);
    }
    static isAndroidApp(userAgent) {
        return userAgent.toLowerCase().includes("android") && this.isApp(userAgent);
    }
    static isIOsApp(userAgent) {
        return (userAgent.toLowerCase().includes("ipad") || userAgent.toLowerCase().includes("iphone") || userAgent.toLowerCase().includes("ios") ) && this.isApp(userAgent);
    }
}
//# sourceMappingURL=UserAgentCheck.js.map